import React from 'react';
import Select from 'react-select';
import UiComponent from '../UiComponent';
import './style.css'

export default class ReactMultiSelectWrapper extends UiComponent {

  constructor(props) {
    super(props);
    this.state = {
      disabled: false,
      searchable: true,
      clearable: true,
    };
    this.updateValue = this.updateValue.bind(this);
    this.getSelectedValues = this.getSelectedValues.bind(this);
    this.getOptions = this.getOptions.bind(this);
  }

  updateValue(newValue) {
    this.props.field.value = newValue.map(v => v.value);
    this.props.onChange(this.props.field.name, this.props.field);
  }

  getOptions() {
    var options = this.props.options || [];
    if (this.props.transformOption){
      options = options.map(this.props.transformOption);
    }
    return options;
  }

  getSelectedValues() {
    if (!this.props.options) return;

    var curValue = this.getFieldProp('value');
    if (curValue){
      if (Array.isArray(curValue)){
        var res = this.props.options
          .filter(o => curValue.includes(o.value));
        return this.props.transformSelected ? res.map(this.props.transformSelected) : res;
      }
    }

    return [];
  }

  render() {
    const { autoFocus = true } = this.props;
    const className = "form-group " + (this.props.className ? this.props.className : '');
    return (
      <div className={className}>
        {this.getLabel()}
        <Select
          closeMenuOnSelect={false}
          autosize={false}
          placeholder={this.props.placeholder}
          autoFocus={autoFocus}
          options={this.getOptions()}
          clearable={this.state.clearable}
          name="selected-state"
          disabled={this.state.disabled || this.props.disabled}
          multi={true}
          value={this.getSelectedValues()}
          onChange={this.updateValue}
          searchable={this.state.searchable}
          className="MultiSelect-control"
        />
        {this.getErrors()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/ReactMultiSelectWrapper/index.js